import React from 'react';
import PropTypes from 'prop-types';
import Status from '../status';
import History from '../assets/components/History';
import './index.css';

/**
 * History
 *
 * Parameters (Props):
 * @param bool disable
 * @param object styles : styles of the within box
 * @param object stylesBox: styles of the outside box
 * @param function onClick
 * @param string size: default medium
 * @param string tooltip: default ''
 */
export default class ButtonHistory extends React.PureComponent {
  render() {
    const { onClick, disable, stylesBox, styles, size, tooltip } = this.props;
    const historySVG = (
      <History
        className={`history ${onClick ? 'button' : ''} ${
          disable ? 'disable' : ''
        } ${size}`}
        style={{ ...styles }}
      />
    );
    return (
      <Status
        disable={disable}
        stylesBox={stylesBox}
        svgImage={historySVG}
        onClick={onClick}
        size={size}
        tooltip={tooltip}
      />
    );
  }
}

ButtonHistory.propTypes = {
  disable: PropTypes.bool.isRequired,
  styles: PropTypes.objectOf(PropTypes.object),
  stylesBox: PropTypes.objectOf(PropTypes.object),
  onClick: PropTypes.func,
  size: PropTypes.string,
  tooltip: PropTypes.string,
};

ButtonHistory.defaultProps = {
  onClick: null,
  stylesBox: {},
  styles: {},
  size: 'medium',
  tooltip: '',
};
